import { render, staticRenderFns } from "./ELMAllianceAuthorization.vue?vue&type=template&id=0ce90ca3"
import script from "./ELMAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./ELMAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce90ca3')) {
      api.createRecord('0ce90ca3', component.options)
    } else {
      api.reload('0ce90ca3', component.options)
    }
    module.hot.accept("./ELMAllianceAuthorization.vue?vue&type=template&id=0ce90ca3", function () {
      api.rerender('0ce90ca3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/ELMAllianceAuthorization.vue"
export default component.exports